<template>
  <div class="loading_message">
    <svgicon class="loading_message__icon" icon="loading" width="64" height="64"></svgicon>
    <p v-if="message">{{message}}</p>
  </div>
</template>

<script>
export default {
  name: "LoadingComponent",
  props: {
    message: String,
  },
};
</script>

<style lang="less">
.loading_message {
  padding: 24px;
  text-align: center;

  &__icon circle{
    animation: bounce 0.7s ease-in 0s infinite alternate;

    &:nth-child(1) {
      animation-delay: 0.25s;
    }

    &:nth-child(2) {
      animation-delay: 0.5s;
    }

    &:nth-child(3) {
      animation-delay: 0s;
    }
  }  
}
</style>
